export default "__VITE_ASSET__BRO9edBb__"